<!-- <tui-loader
  [inheritColor]="true"
  [showLoader]="IsLoadData"
  [overlay]="true"
  class="filter-row"
> -->

<!-- </tui-loader> -->
<div class="Sidebarnav" (click)="func1($event)">
  <input id="menu-toggle" type="checkbox" />
  <label class="menu-button-container" for="menu-toggle">
    <div class="menu-button" (click)="sidebar()"></div>
  </label>
  <!-- <button >click</button> -->
  <!-- <svg
    xmlns="http://www.w3.org/2000/svg"
    (click)="sidebar()"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="w-6 h-6 nv-mb"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    />
  </svg> -->
</div>

<div
  class="mt-4 left-sidebar animate__animated animate__fadeInLeft"
  (click)="func1($event)"
  [ngClass]="isSidebar == true ? '' : 'filter'"
>
  <div
    class="d-flex row flex-row flex-wrap align-items-center mb-2 left-sidebar-in"
  >
    <div class="filters col-12">
      <div>
        <!-- <i class="fa fa-filter mr-2 inline-block" aria-hidden="true"></i> -->
        <h1 class="inline-block">Find best colleges for you:</h1>
        <span class="float-right">
          <a class="reset-btn" (click)="reset()"
            ><span>Clear all</span></a
          ></span
        >
      </div>
    </div>
    <div class="filters pb-0 col-12">
      <div
        class="div mb-2 mt-3 inline-block w-full head efc-cl position-relative"
      >
        <div class="mb-2 autolable mt-1 mr-1 align-items-center">
          <!-- <span><img src="https://cdn.virtueanalytics.com/cache/state-col-sel.png" /></span> -->
          College State
        </div>
        <div class="mp" (click)="OpenMap()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-2 h-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
            />
          </svg>
        </div>
      </div>

      <!-- <ng-multiselect-dropdown
        [Placeholder]="'Select State'"
        enableCheckAll="'false'" 
        class=" "
        [settings]="ddlStateListSetting"
        [data]="stateList"
        [(ngModel)]="stateModelvalue"
        (onSelect)="onMultiItemSelect($event, 'state')"
        (onDeSelect)="onMultiItemDeSelect($event, 'state')"
      >
        <ng-template
          #optionsTemplate
          let-item
          let-option="option"
          let-id="id"
          let-isSelected="isSelected"
        >
          <div class="cust-multi-select" style="padding: 1px 10px">
            <span
              style="display: block; margin-left: 30px"
              [ngStyle]="{ background: isSelected ? 'lightgrey' : '' }"
            >
              {{ option }}
            </span>
          </div>
        </ng-template>
        <ng-template
          #optionSelectedTemplate
          optionSelectedTemplate
          let-option="option"
          let-id="id"
        >
          <div class="cust-multi-select" style="padding: 1px 10px">
            <span style="display: block; margin-left: 30px"> {{ option }}</span>
          </div>
        </ng-template>
      </ng-multiselect-dropdown> -->

      <div class="selected-State" *ngIf="filterStateList.length > 0">
        <span id="notify" *ngIf="AddClickStr"> {{ AddClickStr }} </span>
        <h6>Selected States: {{ filterStateList.length }}</h6>
        <!-- *ngIf="AddClickStr" -->

        <!-- *ngIf="this.stateModelvalue[0].id != state" -->
        <!-- [tippyName]="'Repocity'" -->

        <ng-container *ngFor="let state of filterStateList">
          <span
            class="name"
            (mouseenter)="checkhoverrepocity(state)"
            ngxTippy
            [ngxTippy]="defaultTemplate2"
            [tippyProps]="tippyProps"
            (click)="checkstateIsReciprocity(state)"
            [ngClass]="checkIsReciprocity(state)"
          >
            {{ getStateNameByCode(state) }}
            <a style="padding-left: 2px" (click)="RemoveItem(state)">x</a>
            <div class="col" #defaultTemplate2>
              <span class="ml-2 pl-3">{{ Addhoverstr }}</span>
            </div>
          </span>
        </ng-container>
      </div>
    </div>

    <div class="filters col-md-12">
      <div class="mb-2 mt-3 inline-block w-full head efc-cl position-relative">
        <div style="display: inline-block">Annual Budget</div>
        <div
          class="mb-2 autolable inline-block d-flex align-items-center pkt-cost"
        >
          <a (click)="residency()">
            <!-- <img src="https://cdn.virtueanalytics.com/cache/shorting-icon-top5.png"/> -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"
              />
            </svg>
          </a>
        </div>
        <div
          class="mb-2 autolable inline-block d-flex align-items-center pkt-cost position-relative"
        >
          <div class="hoursadd d-flex align-items-center justify-content-end">
            <div class="lgout header">
              <div class="flex flex-row-reverse items-center">
                <ul class="d-flex align-items-center m-0 p-0">
                  <li
                    [ngClass]="
                      isInternatinalStudent == true ? 'display-none' : 'dropup'
                    "
                  >
                    <a (click)="residency()"
                      ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"
                        />
                      </svg>
                    </a>

                    <div class="dropup-content cost-list">
                      <ul
                        x-transition:leave="transition ease-in duration-150"
                        x-transition:leave-start="opacity-100"
                        x-transition:leave-end="opacity-0"
                        class="absolute cursor-pointer right-0 w-56 p-2 mt-2 bg-gray-100 border-gray-400 shadow space-y-2 text-gray-600 bg-white border border-gray-100 rounded-md shadow-md dark:border-gray-700 dark:text-gray-300 dark:bg-gray-700"
                        aria-label="submenu"
                        style="z-index: 1"
                      >
                        <li
                          class="flex cursor-pointer"
                          *ngFor="let domicilinevaalue of residenceFilterArray"
                        >
                          <span
                            (click)="getdomiciline(domicilinevaalue.value)"
                            [ngClass]="
                              domicilinevaalue.value == DomiclineResidency
                                ? 'active'
                                : ''
                            "
                          >
                            {{ domicilinevaalue.label }}</span
                          >
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- <div *ngIf="isResidencyselected == true" class="cost-list">
            <ul
              x-transition:leave="transition ease-in duration-150"
              x-transition:leave-start="opacity-100"
              x-transition:leave-end="opacity-0"
              class="absolute cursor-pointer right-0 w-56 p-2 mt-2 bg-gray-100 border-gray-400 shadow space-y-2 text-gray-600 bg-white border border-gray-100 rounded-md shadow-md dark:border-gray-700 dark:text-gray-300 dark:bg-gray-700"
              aria-label="submenu"
              style="z-index: 1"
            >
              <li
                class="flex cursor-pointer"
                *ngFor="let domicilinevaalue of residenceFilterArray"
              >
                <span
                  (click)="getdomiciline(domicilinevaalue.value)"
                  [ngClass]="
                    domicilinevaalue.value == DomiclineResidency ? 'active' : ''
                  "
                >
                  {{ domicilinevaalue.label }}</span
                >
              </li>
            </ul>
          </div> -->
      </div>
      <div class="in-option">
        <div>
          <div class="form-control efc-cl cust-div-link max-cost">
            <span
              style="
                position: relative;
                top: 4px;
                display: inline-block;
                left: 0;
              "
              >$</span
            >
            <tui-input-number
              class="currency-input"
              style="display: inline-block; width: 79%"
              type="text"
              [(ngModel)]="pocketcost"
              [prefix]="''"
              [tuiTextfieldLabelOutside]="'true'"
              [pseudoHovered]="'true'"
              [max]="999999999999999"
              [pseudoFocused]="'true'"
              (ngModelChange)="changePocketCost(pocketcost)"
              (keypress)="handleInput($event)"
              class=""
              id="exampleInputPassword1"
            >
              <input
                class="out-max"
                tuiTextfield
                placeholder="Annual Out of Pocket Cost"
              />
            </tui-input-number>
            <div class="clear-icon mt-2">
              <svg
                _ngcontent-ken-c189=""
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
                (click)="clearpocketcost()"
              >
                <path
                  _ngcontent-ken-c189=""
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
            </div>
            <div class="cal-npc m-btn-cl">
              <!-- [disabled]="pocketcost" -->
              <a
                (click)="paymentoption()"
                class="cal-npc-btn"
                [ngClass]="{ disabled: pocketcost }"
                >Compute</a
              >
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="form-control efc-cl">
        <span>$</span>
        <input #inputstyle
          type="text"
          [(ngModel)]="pocketcost"
          maxlength="15"
          (ngModelChange)="changePocketCost(pocketcost)"
          (keypress)="handleInput($event)"
          class=""
          id="exampleInputPassword1"
          placeholder="Max. Out of Pocket Cost"
          
        />
      </div> -->
    </div>
    <!-- Residency -->
    <!-- <div class="filters pb-2 col-12">
        <div class="mb-2 autolable mt-2 inline-block d-flex align-items-center">
        
          Residency Selection
        </div>
        <div class=" in-option ">
          <div>
            <div class="form-control efc-cl residency">
              <select
          type="text"
          class=""
          id="exampleInputPassword1"
          [(ngModel)]="DomiclineResidency"
          (change)="changeDomiclineResidency($event)">
            <option *ngFor="let domicilinevaalue of residenceFilterArray" [value]="domicilinevaalue.value">{{domicilinevaalue.label}}</option></select>
            </div>
          </div>
        </div>
     </div> -->
    <!-- <tui-loader
        [inheritColor]="true"
        [showLoader]="stateList.length==0"
        [overlay]="true"
        class="filter-row"
      > -->

    <!-- </tui-loader> -->

    <div class="filters col-md-12">
      <div class="mb-2 mt-3 inline-block d-flex align-items-center head">
        <!-- <span><img src="https://cdn.virtueanalytics.com/cache/col-type-icon.png" class="col-type" /></span > -->
        College Type
      </div>
      <div
        *ngFor="let rdo of ddlPublicPrivateList; let i = index"
        class="mb-1 col-lab"
      >
        <!-- [checked]="checkedRdoPublic(rdo.value, i)" -->
        <input
          class="ddList"
          type="checkbox"
          [value]="rdo.value"
          (change)="changePublicOption(rdo, $event.target.checked, i)"
          [(ngModel)]="publicModelvalue[i]"
        /><span>{{ rdo?.label }} </span>
      </div>
    </div>

    <!-- <div class="filters col-md-12">
      <div class="mb-2 mt-3 inline-block d-flex align-items-center head">
        College Rank<sup>1</sup>
      </div>
      <div class="mb-1 rank-col">
        <span class="mr-1">
          <input
            [checked]="isProgramRank"
            class="inline-block ml-2 cursor-pointer rang-input-checkbox"
            type="checkbox"
            (change)="checkProgram(isProgramRank)"
          />
        </span>
        Top
        <span>
          <input
            placeholder="Min"
            [ngClass]="!isProgramRank ? 'bg-color-disable' : ''"
            [disabled]="!isProgramRank"
            (keypress)="numbersOnly($event)"
            [(ngModel)]="rankMin"
            (ngModelChange)="changeRank(rankMin, 'min')"
            value="1"
            class="text-base form-control appearance-none shadow-md border border-gray-200 rounded w-full mb-2 py-2 px-3 text-gray-700 leading-tight cust-text"
          />
        </span>
        to
        <span
          ><input
            [disabled]="!isProgramRank"
            [ngClass]="!isProgramRank ? 'bg-color-disable' : ''"
            (keypress)="numbersOnly($event)"
            [(ngModel)]="rankMax"
            placeholder="Max"
            (ngModelChange)="changeRank(rankMax, 'max')"
            value="500"
            class="text-base form-control appearance-none shadow-md border border-gray-200 rounded w-full mb-2 py-2 px-3 text-gray-700 leading-tight cust-text"
        /></span>
      </div>
    </div> -->

    <div class="filters col-md-12" *ngIf="!isInternatinalStudent">
      <div class="mb-2 mt-3 inline-block d-flex align-items-center head">
        Distance
        <!-- <small>(Beta)</small> -->
        <!-- <small>s(Beta)</small> -->
      </div>

      <div class="mb-1 rank-col">
        <span class="mr-1">
          <input
            [checked]="isDistance"
            class="inline-block ml-2 cursor-pointer rang-input-checkbox"
            type="checkbox"
            (change)="checkDistance(isProgramRank)"
          />
        </span>
        Within
        <span
          ><input
            [(ngModel)]="Collegedistancemax"
            (ngModelChange)="collegeDistance(Collegedistancemax, 'collegemax')"
            [ngClass]="!isDistance ? 'bg-color-disable' : ''"
            placeholder="Max"
            collegeDistance
            value="300"
            class="text-base form-control appearance-none shadow-md border border-gray-200 rounded w-full mb-2 py-2 px-3 text-gray-700 leading-tight cust-text"
        /></span>

        miles from my location
      </div>
    </div>

    <div class="filters col-md-12 d-flex flex-row flex-wrap align-items-center">
      <div class="college-nm filters mt-2 mb-0">
        <h1 class="inline-block">Acceptance Rate</h1>
      </div>
      <div class="col-12 p-0">
        <ng-multiselect-dropdown
          [placeholder]="'Select Acceptance Rate'"
          enableCheckAll="'false'"
          class=""
          [settings]="ddlAcceptanceRateListSetting"
          [data]="ddlAcceptanceRate"
          [(ngModel)]="acceptanceRateModelValue"
          (onSelect)="onMultiItemSelect($event, 'acceptanceRate')"
          (onDeSelect)="onMultiItemDeSelect($event, 'acceptanceRate')"
        >
          <ng-template
            #optionsTemplate
            let-item
            let-option="option"
            let-id="id"
            let-isSelected="isSelected"
          >
            <div class="cust-multi-select" style="padding: 1px 10px">
              <span
                style="display: block; margin-left: 30px"
                [ngStyle]="{ background: isSelected ? 'lightgrey' : '' }"
              >
                {{ option }}
              </span>
            </div>
          </ng-template>
          <ng-template
            #optionSelectedTemplate
            optionSelectedTemplate
            let-option="option"
            let-id="id"
          >
            <div class="cust-multi-select" style="padding: 1px 10px">
              <span style="display: block; margin-left: 30px">
                {{ option }}</span
              >
            </div>
          </ng-template>
        </ng-multiselect-dropdown>
      </div>

      <!-- <ul class="nav-pills nav-fill hbcu-ln mb-3">
          <li class="nav-item">
            <a
              class="nav-link"
              [ngClass]="filterAcceptanceRateList.length == 0  ? 'active' : ''"
              (click)="changeAcceptanceRateOption('all')"
              >All</a
            >
          </li>
  
          <li class="nav-item">
            <a
              class="nav-link"
              [ngClass]="filterAcceptanceRateList[0] == 'LOW' ? 'active' : ''"
              (click)="changeAcceptanceRateOption('LOW')"
              >Low</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              [ngClass]="filterAcceptanceRateList[0] == 'HIGH' ? 'active' : ''"
              (click)="changeAcceptanceRateOption('HIGH')"
              >High</a
            >
          </li>
        </ul> -->

      <!-- <ul class="nav-pills nav-fill hbcu-ln mb-3">
        
          <li class="nav-item" *ngFor="let tabs of ddlAcceptanceRate; let i = index" >
            <a
              class="nav-link"
              [ngClass]="acceptanceRateModelValue[0] == tabs.value ? 'active' : ''"
              (click)="changeAcceptanceRateOption(tabs.value)"
              >{{tabs.label}}</a
            >
          </li>
        </ul> -->
    </div>
    <div class="filters col-md-12 d-flex flex-row flex-wrap align-items-center">
      <div class="college-nm filters mt-2 mb-0">
        <h1 class="inline-block">Enrollment Type</h1>
      </div>
      <ul class="nav-pills nav-fill hbcu-ln mb-3">
        <li class="nav-item">
          <a
            class="nav-link"
            [ngClass]="enrollmentType.length == 0 ? 'active' : ''"
            (click)="changeEnrollmentType('all')"
            >All</a
          >
        </li>

        <li class="nav-item">
          <a
            class="nav-link"
            [ngClass]="enrollmentType[0] == 'FOUR_YEAR_PROGRAM' ? 'active' : ''"
            (click)="changeEnrollmentType('FOUR_YEAR_PROGRAM')"
            >4-Year</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            [ngClass]="enrollmentType[0] == 'TWO_YEAR_PROGRAM' ? 'active' : ''"
            (click)="changeEnrollmentType('TWO_YEAR_PROGRAM')"
            >2-Year</a
          >
        </li>
      </ul>
    </div>

    <div class="filters col-md-12 d-flex flex-row flex-wrap align-items-center">
      <div class="college-nm position-relative mt-2 mb-0">
        <h1 class="inline-block">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6 mr-2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
            />
          </svg>
          Select College
        </h1>
        <!-- duplicate Icon -->
        <div
          class="mb-2 autolable inline-block d-flex align-items-center pkt-cost position-relative"
        >
          <div class="hoursadd d-flex align-items-center justify-content-end">
            <div class="lgout header">
              <div class="flex flex-row-reverse items-center">
                <ul class="d-flex align-items-center m-0 p-0">
                  <li class="dropup">
                    <a (click)="duplicateresidency()"
                      ><img
                        src="https://cdn.virtueanalytics.com/cache/shorting-icon-top5.png"
                    /></a>

                    <div class="dropup-content cost-list">
                      <ul
                        x-transition:leave="transition ease-in duration-150"
                        x-transition:leave-start="opacity-100"
                        x-transition:leave-end="opacity-0"
                        class="absolute cursor-pointer right-0 w-56 p-2 mt-2 bg-gray-100 border-gray-400 shadow space-y-2 text-gray-600 bg-white border border-gray-100 rounded-md shadow-md dark:border-gray-700 dark:text-gray-300 dark:bg-gray-700"
                        aria-label="submenu"
                        style="z-index: 1"
                      >
                        <li
                          class="flex cursor-pointer"
                          *ngFor="let sortBy of collegeSortByList"
                        >
                          <span
                            (click)="ChangeSorting(sortBy.value)"
                            [ngClass]="
                              sortBy.value == collegeSortBy ? 'active' : ''
                            "
                          >
                            {{ sortBy.label }}</span
                          >
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- <div *ngIf="isduplicateResidencyselected == true" class="cost-list">
            <ul
              x-transition:leave="transition ease-in duration-150"
              x-transition:leave-start="opacity-100"
              x-transition:leave-end="opacity-0"
              class="absolute cursor-pointer right-0 w-56 p-2 mt-2 bg-gray-100 border-gray-400 shadow space-y-2 text-gray-600 bg-white border border-gray-100 rounded-md shadow-md dark:border-gray-700 dark:text-gray-300 dark:bg-gray-700"
              aria-label="submenu"
              style="z-index: 1"
            >
              <li
                class="flex cursor-pointer"
                *ngFor="let domicilinevaalue of residenceFilterArray"
              >
                <span
                  (click)="getdomiciline(domicilinevaalue.value)"
                  [ngClass]="
                    domicilinevaalue.value == DomiclineResidency ? 'active' : ''
                  "
                >
                  {{ domicilinevaalue.label }}</span
                >
              </li>
            </ul>
          </div> -->
      </div>
      <ul class="nav-pills nav-fill hbcu-ln mb-3">
        <li class="nav-item">
          <a
            class="nav-link"
            [ngClass]="collegeType == 'Included' ? 'active' : ''"
            (click)="changeCollege('Included')"
            >All Colleges</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            [ngClass]="collegeType == 'Excluded' ? 'active' : ''"
            (click)="changeCollege('Excluded')"
            >Non-HBCU</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            [ngClass]="collegeType == 'Only' ? 'active' : ''"
            (click)="changeCollege('Only')"
            >Only HBCU</a
          >
        </li>
      </ul>

      <tui-loader
        [inheritColor]="true"
        [showLoader]="IsLoadData"
        [overlay]="true"
        class="filter-row"
      >
        <div
          class="college-nm"
          [ngClass]="collegeList.length == 0 ? 'disableDiv' : ''"
        >
          <div class="dialog-col overscroll-x-none">
            <ng-container *ngIf="viewMoreList == false">
              <div
                *ngFor="let a of collegeList; let i = index"
                class="border-b-1 border-slate-100 mb-1 d-flex align-items-center pl-1"
              >
                <input
                  [disabled]="checkDisabled(i, a)"
                  class="inline-block"
                  [ngClass]="
                    checkDisabled(i, a) == false
                      ? 'chk-college'
                      : 'chk-college-disable'
                  "
                  type="checkbox"
                  [(ngModel)]="collegeModelvalue[i]"
                  (change)="getSelectedValue(a, collegeModelvalue[i], i)"
                />
                <span
                  class="top-link"
                  ngxTippy
                  [ngxTippy]="defaultTemplate2"
                  [tippyProps]="tippyProps"
                  [tippyName]="
                    'viewless_collegeName_' + a.collegeName + '-' + i
                  "
                >
                  <div>
                    <span class="ml-2 text-truncate"
                      >{{ a.collegeName }} ({{ a?.stateCode }})</span
                    >

                    <!-- <span class="ml-2">{{a.stateCode}}</span> -->

                    <!-- <span *ngIf="a?.stateCode">{{ a.stateCode }}</span> -->
                    <!-- <span *ngIf="a?.overallCollegeRankInUS"> Rank: {{ a.overallCollegeRankInUS }}</span> -->
                    <!-- <span *ngIf="a?.collegeType">, {{ getControlType(a.collegeType) }}</span> -->
                  </div>

                  <div class="col" #defaultTemplate2>
                    <span class="ml-2 pl-3">{{ a.collegeName }}</span>
                  </div>
                </span>
              </div>
              <div *ngIf="collegeList.length > 10">
                <span (click)="clickviewMoreList()" class="view-more-list"
                  >View less</span
                >
              </div>
            </ng-container>
            <ng-container *ngIf="viewMoreList == true">
              <ng-container *ngFor="let a of collegeList; let i = index">
                <div
                  *ngIf="i < 10"
                  class="border-b-1 border-slate-100 mb-1 d-flex align-items-center pl-1"
                >
                  <input
                    [disabled]="checkDisabled(i, a)"
                    class="inline-block"
                    [ngClass]="
                      checkDisabled(i, a) == false
                        ? 'chk-college'
                        : 'chk-college-disable'
                    "
                    type="checkbox"
                    [(ngModel)]="collegeModelvalue[i]"
                    (change)="getSelectedValue(a, collegeModelvalue[i], i)"
                  />
                  <span
                    class="top-link"
                    ngxTippy
                    [ngxTippy]="defaultTemplate2"
                    [tippyProps]="tippyProps"
                    [tippyName]="
                      'viewMore_collegeName_' + a.collegeName + '-' + i
                    "
                  >
                    <div>
                      <span class="ml-2 text-truncate"
                        >{{ a.collegeName }} ({{ a?.stateCode }})</span
                      >
                      <!-- <span class="ml-2">{{a.stateCode}}</span> -->
                      <!-- <span *ngIf="a?.stateCode">{{ a?.stateCode }}</span> -->

                      <!-- <span *ngIf="a?.overallCollegeRankInUS"> Rank: {{ a.overallCollegeRankInUS }}</span>
                  <span *ngIf="a?.collegeType">, {{ getControlType(a.collegeType) }}</span> -->
                    </div>
                    <div class="col" #defaultTemplate2>
                      <span class="ml-2 pl-3">{{ a.collegeName }}</span>
                    </div>
                  </span>
                </div>
              </ng-container>
              <div>
                <span (click)="clickviewMoreList()" class="view-more-list"
                  >View more...</span
                >
              </div>
            </ng-container>
          </div>
        </div>
      </tui-loader>
    </div>
  </div>
</div>
